import { IconTypes } from './Icons'

export default function Crown({ color = 'white', fontSize = '1.6rem', rotate = 0, className = '' }: IconTypes) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ width: '1em', height: '1em', fontSize, transform: `rotate(${rotate}deg)` }}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1113_89)">
        <path d="M10.7124 5.3125C11.0687 5.09375 11.3062 4.69687 11.3062 4.25C11.3062 3.55937 10.7468 3 10.0562 3C9.36553 3 8.80615 3.55937 8.80615 4.25C8.80615 4.7 9.04365 5.09375 9.3999 5.3125L7.60928 8.89375C7.3249 9.4625 6.5874 9.625 6.09053 9.22813L3.30615 7C3.4624 6.79063 3.55615 6.53125 3.55615 6.25C3.55615 5.55938 2.99678 5 2.30615 5C1.61553 5 1.05615 5.55938 1.05615 6.25C1.05615 6.94062 1.61553 7.5 2.30615 7.5H2.32803L3.75615 15.3562C3.92803 16.3062 4.75615 17 5.7249 17H14.3874C15.353 17 16.1812 16.3094 16.3562 15.3562L17.7843 7.5H17.8062C18.4968 7.5 19.0562 6.94062 19.0562 6.25C19.0562 5.55938 18.4968 5 17.8062 5C17.1155 5 16.5562 5.55938 16.5562 6.25C16.5562 6.53125 16.6499 6.79063 16.8062 7L14.0218 9.22813C13.5249 9.625 12.7874 9.4625 12.503 8.89375L10.7124 5.3125Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1113_89">
          <rect width="18" height="16" fill="white" transform="translate(1.05615 2)" />
        </clipPath>
      </defs>
    </svg>
  )
}